<template>
<div class="price">
    <span class="current currency" itemprop="price" :content="price.price">{{ $money(price.price) }}</span>
    <template v-if="price.discount">
        <span class="old currency">{{ $money(price.discount.oldPrice) }}</span>
        <span class="badge">{{ price.discount.percent }}</span>
    </template>
    <meta itemprop="priceCurrency" content="RUB"/>

    <div class="coupon" v-if="suggestedCoupon">{{ suggestedCoupon.c }} <i class="ti-copy"></i></div>

    <!-- {{ suggestedCoupon }} -->
</div>
</template>

<script setup lang="ts">
import { maxBy } from 'lodash-es';
import { useCartCouponStore } from '~/store/cartCouponStore';
import type { IOfferPrice } from '~/types/catalog';

const props = defineProps<{
    price: IOfferPrice
}>();

const couponStore = useCartCouponStore();

const suggestedCoupon = computed(() => {
    if (!props.price.discount) {
        return 0;
    }

    const availableCoupons = couponStore.availableCouponBadges
        .filter((el) => props.price.discount!.type & (1 << el.i));

    if (!availableCoupons.length) {
        return 0;
    }

    return maxBy(availableCoupons, 'v');

    // return Math.max(...availableCoupons);
});


</script>

<style lang="scss" scoped>

.price {
    display: flex;
    align-items: center;
    gap: 12px;
}

.current {
    font-weight: 600;
    font-size: 18px;
    color: var(--t0);
}

.old {
    font-weight: 300;
    font-size: 14px;
    color: var(--t2);
    position: relative;
    margin-top: 2px;

    &::before {
        position: absolute;
        left: 0;
        right: 0;
        top: calc(50%);
        height: 1px;
        background-color: currentColor;
        opacity: .5;
        display: block;
        content: ' ';
    }
}

.badge {
    font-size: 14px;
    border-radius: 8px;
    color: white;
    background-color: var(--pink);
    
    font-weight: 550;
    padding: 4px 8px;
    user-select: none;

    &::before {
        content: '-';
    }

    &::after {
        content: '%';
    }
}

.coupon {
    align-items: center;
    font-size: 12px;
    background-color: #ADE4FF;
    color: #2e3d44;
    padding: 2px 4px;
    border-radius: 4px;
    user-select: none;
    cursor: pointer;

    i {
        position: relative;
        top: 1px;
        margin-left: 2px;
        cursor: pointer;
    }
}


</style>